import getAppUrl from './getAppUrl';

export default function redirectToApp() {
  const redirectDomain = getAppUrl();
  const isLocal = window.location.host.includes('localhost');
  if (!isLocal) {
    location.href = `${redirectDomain}/${window.location.search}`;
  }
}
